var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"material-kit"}},[_c('div',{class:{ 'nav-open': _vm.NavbarStore.showNavbar }},[_c('div',[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }